import { Entity } from "@/app/common/base/entity"
import { Expose, Type } from "class-transformer"
import { NpsFollowUp } from "@/app/nps-feedback/entities/nps-follow-up.entity"

export class NpsResult extends Entity<NpsResult> {
    @Expose({ name: 'result_id' })
    resultId!: string

    @Expose({ name: 'follow_up' })
    @Type(() => NpsFollowUp)
    followUp?: NpsFollowUp

    @Expose({ name: 'free_answer_prompt' })
    freeAnswerPrompt?: string
}
